<template>
  <div class="main-container">
    <div class="multislider" ref="sliderContainer">
      <div
        :style="{
          width: `${division.widthInPercentage}%`,
          'background-color': `#${this.getBackgroundColor(division?.product)}`,
          'border-radius': `${this.getBorderRadius(i)}`,
          'border-color': `${this.getBorderColor(i, division?.product?.color)}`,
        }"
        class="division px-2"
        v-for="(division, i) in this.currentPlanData.divisions"
        :key="division.id"
        @click="openSelectProductsModal(division)"
        ref="divisions">
        <img class="icon-multisplider" v-if="division.product" :src="division?.product?.icon" alt="product icon" />
        {{ division.product?.name
        ? `${ division.widthInPercentage > 15 ? `${division.product.name} -` : ""} ${Math.round(division.sizeInHectares)} has.`
        : `Potrero ${division.id} - ${Math.round(division.sizeInHectares)} has.`
        }}
        <div :id="division.id" v-if="i != this.currentPlanData.divisions.length - 1" class="dragger"
          @mousedown="dragMouseDown">{{' <>'}}
        </div>
      </div>
    </div>
    <n-tooltip trigger="hover">
      <template #trigger>
        <button :class="this.currentPlanData.divisions.length == 4 ? 'add-division-button disabled-btn' : 'add-division-button'" @click="addDivision">
           <i class="icon-plus"></i> División
          </button>
      </template>
      <span v-show="this.currentPlanData.divisions.length < 4">Agregar división</span>
      <span v-show="this.currentPlanData.divisions.length == 4">Cantidad máxima de divisiones 4</span>
    </n-tooltip>
    <divisionModal v-if="showDivisionModal" :divisionData="selectedDivision"
      :products="products" @triggerCloseModal="handleCloseModal" />
  </div>
</template>

<script>
let initialX = 0, element
import { mapActions, mapState } from "pinia";
import planStore from "../store/plan";
import divisionModal from "./divisionModal.vue"
export default {
  name: "new-multislider",
  props: {
    products: Array,
  },
  data() {
    return {
      showDivisionModal: false,
      selectedDivision: {},
      sliderWidth: 25,
      isDragging: false,
    };
  },
  methods: {
    ...mapActions(planStore, ['updateCurrentPlanData', 'getWidthInPercentage', 'getSizeInHectaresByPercentage']),
    handleCloseModal() {
      this.showDivisionModal = false;
      this.selectedDivision = {}
    },
    getPercentage(containerWidth, distanceMoved) {
      return (distanceMoved / containerWidth) * 100;
    },
    dragMouseDown(e) {
      element = e.target;
      // element would be the slider the user clicks in
      e.preventDefault();
      e.stopPropagation();
      // get the mouse cursor position at startup:
      initialX = e.clientX;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
      this.isDragging = true

    },
    closeDragElement(e) {
      setTimeout(() => {
        this.isDragging = false
      }, 500);
      document.onmouseup = null;
      document.onmousemove = null;
      e.stopPropagation();
    },
    limitNumberWithinRange(value, min, max) {
      // Give a range of values to limit user input
      return Math.min(Math.max(value, min), max)
    },
    elementDrag(e) {
      const divisionsDOMArray = this.$refs.divisions

      let index = Number(element.id - 1)
      // If i clicked on an element with id === 1 then the index will be 0
      // Therefore I want to modify the first and second divisions
      const leftDivisionDOMElement = divisionsDOMArray[index]

      const leftDivision = this.currentPlanData.divisions[index]
      const rightDivision = this.currentPlanData.divisions[index + 1]
      // Objects from pinia store, left and right relative to the slider the user clicked in

      let distanceMoved = (initialX - e.clientX) / 3; // This division controls the 'aceleration' when moving the mouse
      // Calculate how much the cursor moved in pixels

      const percentageMoved = this.getPercentage(leftDivisionDOMElement.offsetWidth, distanceMoved);
      /*
      We use percentages to normalize values from px to hectares, so if I moved 10% of the total width of the container
      And this division goes from 100px width => 200px width, then the hectares should grow as much
      */

      const minSizeInPercentage = 10
      const maxSizeInPercentage = (leftDivision.widthInPercentage - percentageMoved + rightDivision.widthInPercentage + percentageMoved) - minSizeInPercentage
      /*
      Then we gotta limit how much a division can grow or shrink, depending on the direction the cursor moves one will shrink and the otherone will grow and viceversa
      We define a minimum of 10% (otherwise you can't actually read the text inside of it, but this can change if the product owner wishes)
      The max a division can grow is the projected sum of size in percentages of each division minus the min size (this is important because otherwise if you've reach the ideal limit of how much the left one can grow but the left one can in theory grow an extra 10%, it will, resulting on the divisions after it shrinking as well.) 
      */

      initialX = e.clientX;
      // Redefine the starting point

      leftDivision.widthInPercentage = this.limitNumberWithinRange(
        leftDivision.widthInPercentage - percentageMoved,
        minSizeInPercentage,
        maxSizeInPercentage
      )
      rightDivision.widthInPercentage = this.limitNumberWithinRange(
        rightDivision.widthInPercentage + percentageMoved,
        minSizeInPercentage,
        maxSizeInPercentage
      )
      // Apply the previously explained validation

      leftDivision.sizeInHectares = this.getSizeInHectaresByPercentage(leftDivision.widthInPercentage)

      rightDivision.sizeInHectares = this.getSizeInHectaresByPercentage(rightDivision.widthInPercentage)
      // Use the new percentages to recalculate the change in hectares
    },
    async addDivision() {
      if (this.currentPlanData.divisions.length === 4) return;
      let divisionsClone = [...this.currentPlanData.divisions];
      let lastItem = divisionsClone.pop();
      let newDivision = {
        id: lastItem.id + 1,
        product: null,
        sizeInHectares: lastItem.sizeInHectares % 2 == 0 ? Math.round(lastItem.sizeInHectares / 2) : Math.round(lastItem.sizeInHectares / 2) - 1,
        widthInPercentage: this.getWidthInPercentage(this.currentPlanData.totalSize, lastItem.sizeInHectares / 2),
      };

      lastItem.sizeInHectares = Math.round(lastItem.sizeInHectares / 2),
      lastItem.widthInPercentage = this.getWidthInPercentage(this.currentPlanData.totalSize, lastItem.sizeInHectares);
      divisionsClone = [...divisionsClone, lastItem, newDivision];
      await this.updateCurrentPlanData(divisionsClone, 'divisions')
    },

    openSelectProductsModal(division) {
      if (!this.isDragging) {
        this.showDivisionModal = true;
        this.selectedDivision = division
      }
    },
  },
  computed: {
    ...mapState(planStore, ['currentPlanData']),
    fatherDivWidth() {
      if (!this.$refs.sliderContainer) {
        return 0;
      } else {
        return this.$refs.sliderContainer && this.$refs.sliderContainer.offsetWidth;
      }
    },
    availableBarWidth() {
      return this.fatherDivWidth - this.sliderWidth;
    },
    getBackgroundColor() {
      return (product) => {
        if (product) {
          return product.color
        } else {
          return "e5e5e5"
        }
      }
    },
    getBorderRadius() {
      return (index) => {
        if (index === 0) {
          if (this.currentPlanData.divisions.length === 1) return "10px";
          return "10px 0 0 10px";
        } else if (index === this.currentPlanData.divisions.length - 1) {
          return "0 10px 10px 0";
        } else {
          return "0";
        }
      };
    },
    getBorderColor() {
      return (index, productColor) => {
        if (index === 0) {
          if (this.currentPlanData.divisions.length === 1) return productColor ? `#${productColor}` : "#e5e5e5";
          return productColor ? `#${productColor} #606060 #${productColor} #${productColor}` : "#e5e5e5 #606060 #e5e5e5 #e5e5e5";
        } else if (index === this.currentPlanData.divisions.length - 1) {
          return productColor ? `#${productColor} #${productColor} #${productColor} #606060` : "#e5e5e5 #e5e5e5 #e5e5e5 #606060";
        } else {
          return productColor ? `#${productColor} #606060 #${productColor} #606060` : "#e5e5e5 #606060 #e5e5e5 #606060";
        }
      };
    },
  },
  components: { divisionModal }
};
</script>
<style scoped>
.select-products-modal {
  width: 50rem;
  height: 20rem;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #e5e5e5;
  border: 1px dashed red;
}

.dragger {
  cursor: ew-resize;
  font-weight: 700;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  color: #606060;
}

.division {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* background-color: #e5e5e5; */
  background-color: var(--light-gray);
  border: 1px solid;
  position: relative;
  color: var(--dark-gray);
}

.add-division-button {
  /* position: absolute; */
  /* right: -6vw; */
  border: var(--light-gray);
  background-color: var(--light-gray);
  border: var(--brand-secondary-color);
  background-color: var(--brand-secondary-color);
  width: auto;
  height: 42px;
  border-radius: 5px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  border-radius: var(--main-border-radius);
  color: var(--dark-gray);
  color: var(--white);
}
.icon-plus{
  margin-right: 5px;
}

.disabled-btn {
  color: #9E9E9E;
  color: green;
  cursor: default;
}

.main-container {
  position: relative;
  margin-bottom: 2rem;
  width: 65rem;
  width: 85vw;
  height: 2rem;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  z-index: 1;
}

.multislider {
  min-height: 42px;
  /* background-color: #e5e5e5; */
  background-color: var(--light-gray);
  height: 100%;
  border-radius: var(--main-border-radius);
  border: 1px solid #e5e5e5;
  display: flex;
  font-size: 0.84rem;
  justify-content: center;
  align-items: center;
  width: 78vw;
}
.multislider-add-btn {
  min-height: 42px;
  min-width: 42px;
}

.icon-multisplider {
  margin-right: 5px;
  width: 1.5rem;
}

@media screen and (max-width: 700px) {
  .main-container {
    margin-bottom: 2rem;
    width: 72vw;
    /* margin-left: 13vw; */
    gap: 0.4rem;
    width: 98vw;
    margin-left: 1vw;
  }
  
  .multislider {
    font-size: 0.65rem;
    width: 78vw;
  }

  .add-division-button {
    width: 17.5vw;
    font-size: 0.75rem;
  }

  .dragger {
  cursor: ew-resize;
  display: none;
}

}

</style>
